module.exports = __webpack_public_path__ + "img/02_noff_close_L2.82a1c7cc.svg";